// src/components/button/BtnRemoveAllSensors.tsx

import { RemoveTwoTone } from '@mui/icons-material'
import {
  IconButton,
  IconButtonProps,
  SxProps,
  Theme,
  Tooltip,
} from '@mui/material'

type BtnRemoveAllSensorsProps = {
  onClick: () => void
  sx: SxProps<Theme>
} & IconButtonProps

export const BtnRemoveAllSensors = ({
  onClick,
  sx,
}: BtnRemoveAllSensorsProps) => (
  <Tooltip title={'Dem Sensor alle Benutzer entziehen'}>
    <IconButton onClick={onClick} sx={sx}>
      <RemoveTwoTone />
    </IconButton>
  </Tooltip>
)
